import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ArticleView from '../components/article/ArticleView';
import PageLoader from '../components/common/PageLoader';
import { newsApi } from '../utils/api';

function ArticlePage({ allNews, onOpen }) {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let mounted = true;
    const fetchArticle = async () => {
      setLoading(true);
      try {
        // Instant paint from cached list (purano views count huna sakcha)
        const newsArray = Array.isArray(allNews) ? allNews : [];
        const local = newsArray.find((n) => n.id === parseInt(id));
        if (local && mounted) setArticle(local);

        // Fresh fetch — server le views +1 garera NAYA count pathauchha,
        // tyahi real count display hunchha
        try {
          const response = await newsApi.getOne(parseInt(id));
          if (mounted && response.data) setArticle(response.data);
          else if (!local && mounted) setNotFound(true);
        } catch (e) {
          if (mounted && !local) setNotFound(true);
        }
      } catch (e) {
        if (mounted) setNotFound(true);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchArticle();
    return () => { mounted = false; };
  }, [id, allNews]);

  if (loading) {
    return <main className="max-w-[1240px] mx-auto px-5 pt-7 w-full"><PageLoader /></main>;
  }

  if (notFound || !article) {
    return <main className="max-w-[1240px] mx-auto px-5 pt-7 w-full"><p className="text-muted py-10">समाचार फेला परेन।</p></main>;
  }

  // Sharp meta tags — social media ma share garda photo + title + description dekhinchha
  const metaTitle = article.title || 'KaloNews';
  const metaDescription = (article.excerpt || article.subtitle || '').slice(0, 200);
  const metaImage = article.image || (() => {
    try {
      const photos = JSON.parse(article.photos || '[]');
      return Array.isArray(photos) && photos[0] ? photos[0] : '';
    } catch {
      return '';
    }
  })();
  const metaUrl = typeof window !== 'undefined' ? window.location.href : '';
  const fullImage = metaImage && !/^https?:\/\//i.test(metaImage)
    ? `${window.location.origin}${metaImage}`
    : metaImage;

  return (
    <>
      <Helmet>
        <title>{metaTitle} &mdash; KaloNews</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="KaloNews" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={metaUrl} />
        {fullImage && <meta property="og:image" content={fullImage} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        {fullImage && <meta name="twitter:image" content={fullImage} />}
      </Helmet>
      <ArticleView item={article} allNews={allNews} onOpen={onOpen} />
    </>
  );
}

export default ArticlePage;